const qaList = [
    {
        "Id": 1,
        "Question": "本次招聘面向哪些专业类别的学生？其他类别专业的学生是否完全没机会？",
        "Answer": "材料、化学、环保、机械、电气、工业工程等，详见各岗位的具体要求。" +
            "学历和专业只是参考的一个方面，学生的基本素质以及对技术的追求和对专业的热爱，" +
            "才是我们更为看重的，只要你的兴趣和能力与职位相符，都可以申请投递。"
    },
    {
        "Id": 2,
        "Question": "简历投递有哪几种方式？",
        "Answer": "有两种。①校招网站投递：您可以通过“智联”和“前程无忧”进行网申；②官方招聘邮箱投递：您可以将简历发送至zhaopin@haistar.com.cn；"
    },
    {
        "Id": 3,
        "Question": "我能同时申请多个职位吗？",
        "Answer": "为保证简历筛选的有效性，您最多可以投递两个职位。如果觉得专业不是特别相关，对未来职位不是特别确定的，" +
            "但是个人的基本素质高，尽量选择管理培训生岗位。管理培训生在公司有轮岗锻炼的机会，届时可以结合个人兴趣和公司安排双向选择定岗。"
    },
    {
        "Id": 4,
        "Question": "网申过后，我该如何得知简历评审结果及面试信息？",
        "Answer": "凡符合招聘基本条件的同学，都将通过短信、微信、邮件、电话等形式收到面试通知。请同学们确保简历上所留的电话及邮箱能够准确联系到您。"
    },
    {
        "Id": 5,
        "Question": "工作地点在哪里？是个怎样的城市？",
        "Answer": "公司总部位于江苏省南通市，地处高铁新城平潮，交通方便，上海一小时经济圈内。" +
            "同时在四川雅安、宁夏石嘴山、新疆霍尔果斯有三个大型生产基地。同时，在上海、广州、香港、日本等地设有子公司和办事处。"
    },
    {
        "Id": 6,
        "Question": "公司对新人的培养有哪些具体措施？",
        "Answer": "公司建有自己的企业大学——海星学院，有完备的人才培养体系。针对应届毕业生群体，采取7-2-1培养模式。" +
            "培训学习占10%，包括：入职集中培训、在线学习平台自主学习、后备梯队领导力发展项目。导师辅导占20%，" +
            "包括：优秀经理人担任工作导师、高管面对面、公司级项目参与等。在岗实践占70%，包括：一线生产实习、在岗锻炼、总部/子公司轮岗等。"
    },
    {
        "Id": 7,
        "Question": "南通市的人才政策有哪些？",
        "Answer": "无条件落户，同时人才激励很丰厚：普通本科生给予每月1000元生活津贴，共计发放三年；" +
            "双一流本科生给予每月1800元生活津贴，共计发放三年，另有8万购房补贴；硕士给予每月3000元生活津贴，共计发放三年，另有25万购房补贴；" +
            "博士给予每月5000元生活津贴，共计发放三年，另有50万购房补贴。符合一定条件者可申请延长生活补贴由3年至5年。"
    }
]

export function getQaList() {
    return qaList
}



// WEBPACK FOOTER //
// ./src/mock/qa.js